import { render, staticRenderFns } from "./imgTab.vue?vue&type=template&id=48d2bacb&scoped=true&"
import script from "./imgTab.vue?vue&type=script&lang=js&"
export * from "./imgTab.vue?vue&type=script&lang=js&"
import style0 from "./imgTab.vue?vue&type=style&index=0&id=48d2bacb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2bacb",
  null
  
)

export default component.exports